import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowDown, ArrowLeft } from "lucide-react";
import ShreeDay from "../../Charts/starLinePanaChart/7PM";
import ShreeNight from "../../Charts/starLinePanaChart/8PM";
import MadhurDay from "../../Charts/starLinePanaChart/12PM";
import MadhurNight from "../../Charts/starLinePanaChart/1PM";
import MilanDay from "../../Charts/starLinePanaChart/3PM";
import MilanNight from "../../Charts/starLinePanaChart/4PM";
import RajdhaniDay from "../../Charts/starLinePanaChart/5PM";
import RajdhaniNight from "../../Charts/starLinePanaChart/6PM";
import Kalyan from "../../Charts/starLinePanaChart/10Am";
import KalyanNight from "../../Charts/starLinePanaChart/11Am";
import MainBazar from "../../Charts/starLinePanaChart/2PM";
import TimeBazar from "../../Charts/starLinePanaChart/9PM";
import AllStarline from "../../Charts/starLinePanaChart/AllStarline";
import { nameRejext } from "../../Helpers/StringRejex";
import { GetAllCharts } from "../../Helpers/GetCharts";
import Footer from "../../Pages/Footer/Footer";
import Navbar from "../../Pages/Navbar/Navbar";
import { GET_ALL_STARLINE_GAME_PANA_CHART } from "../../service/admin.service";

const Starline_Chart = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getData, setgetData] = useState([]);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getResponseData = async () => {
    if (location.state.title !== "allratanstarline") {
      const req = location.state;
      const res = await GetAllCharts(GET_ALL_STARLINE_GAME_PANA_CHART, req);
      setgetData(res);
    }
  };

  useEffect(() => {
    getResponseData();
  }, []);

  const renderChart = () => {
    const chartMap = {
      "7:00PM": ShreeDay,
      "8:00PM": ShreeNight,
      "12:00PM": MadhurDay,
      "1:00PM": MadhurNight,
      "3:00PM": MilanDay,
      "4:00PM": MilanNight,
      "5:00PM": RajdhaniDay,
      "6:00PM": RajdhaniNight,
      "10:00Am": Kalyan,
      "11:00Am": KalyanNight,
      "9:00PM": TimeBazar,
      "2:00PM": MainBazar,
      allratanstarline: AllStarline,
    };

    const normalizedTitle = nameRejext(location.state.title);
    const ChartComponent = Object.entries(chartMap).find(
      ([key]) => nameRejext(key) === normalizedTitle,
    )?.[1];

    return ChartComponent ? <ChartComponent chartData={getData.data} /> : null;
  };

  const isAllStarline = location.state.title === "allratanstarline";
  const chartTitle = isAllStarline ? "" : location.state.title;

  useEffect(() => {
    // scroll top fix
    window.scrollTo({ top: 0, behavior: "smooth" });
    getResponseData();
  }, []);
  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />

      <div className="tw-pt-8 tw-px-0 md:tw-px-8 lg:tw-px-16 tw-min-h-screen lg:tw-mt-20 tw-mt-12">
        <div className="tw-max-w-6xl tw-mx-auto">
          {/* Header */}
          <div className="tw-text-center tw-px-4 md:tw-px-8 tw-mb-8">
            <h1 className="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-gray-900 tw-mb-3">
              Starline {chartTitle} Pana Chart
            </h1>
            <p className="tw-text-gray-600 tw-text-xs md:tw-text-sm tw-max-w-3xl tw-mx-auto tw-mb-6">
              {chartTitle} Pana Chart lets you easily check old records, result
              history, bracket details, live updates, and complete number charts
              for better tracking.
            </p>
            <button
              onClick={handleClick}
              className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mx-auto tw-transition-colors"
            >
              Go To Bottom
              <ArrowDown className="tw-w-4 tw-h-4" />
            </button>
          </div>

          {/* Chart Container */}
          <div className="md:tw-bg-white  tw-shadow-sm tw-p-0 md:tw-p-6 tw-overflow-x-auto">
            <div className="tw-min-w-full">{renderChart()}</div>
          </div>

          {/* Back Button */}
          <div className="tw-flex tw-justify-center tw-mt-3 md:tw-mt-8">
            <button
              onClick={() => navigate(-1)}
              className="tw-bg-[#1e6ebe]  tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-transition-colors"
            >
              <ArrowLeft className="tw-w-4 tw-h-4" />
              Back
            </button>
          </div>
        </div>
      </div>

      <Footer variant="mini" />
      <div id="scroll-down"></div>
    </>
  );
};

export default Starline_Chart;
